module.exports = __webpack_public_path__ + "static/media/world2.e2302406.svg";